import React from "react";
import UserHeader from "./UserHeader";
import AdminOverview from "./AdminOverview";

const AdminLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <UserHeader />
      <div className="p-2 sm:p-6">
        <AdminOverview />
      </div>
    </div>
  );
};

export default AdminLayout;
